import { HttpErrorResponse } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { ToasterService } from 'src/app/shared/services/toaster.service';

export class BaseEffect {
    private readonly isDevEnvironment: boolean;

    constructor(protected readonly toasterService: ToasterService) {
        this.isDevEnvironment = isDevMode();
    }

    protected handleSuccess(success: any) {
        return this.toasterService.toast(success);
    }

    protected handleStringError(error: string) {
        return this.toasterService.toast(error);
    }

    protected handleError(error: HttpErrorResponse) {
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred.
            errorMessage = `An error occurred: ${error.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            errorMessage = `A backend error occurred: ${error.status}\nMessage: ${error.message}`;
        }

        this.logError(error);
        this.toasterService.toast(errorMessage);
    }

    protected logData(obj: any) {
        // It’s better to disable debugging messaging output so that it can only be used locally
        if (this.isDevEnvironment) {
            console.log(obj);
        }
    }

    protected logError(obj: any) {
        console.error(obj);
    }
}
